export default "/images/vendor/flag-icon-css/flags/1x1/so.svg?1ace29c02ffbda05c917174819f13dc7";